import React, { useState } from 'react';
import {
    Card, CardContent, Typography, Grid, TextField, Select, MenuItem,
    FormControl, InputLabel, Divider, Button, Paper, FormControlLabel,
    Checkbox, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Box,     Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';

const Mapping = () => {
    const [searchOpNumber, setSearchOpNumber] = useState('');
    const [searchResult, setSearchResult] = useState(null);
    const [isFormVisible, setIsFormVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [saveStatus, setSaveStatus] = useState({ message: '', severity: '' });
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [password, setPassword] = useState('');
  const [downloadFormat, setDownloadFormat] = useState('excel');
    const [error, setError] = useState('');
    const [formData, setFormData] = useState({
        date: '',
        impedance: '',
        impedanceRemark: '',
        mappingTable: Array(4).fill().map(() => ({ programNo: '', mapNo: '', details: '', remarks: '' })),
        nextAppointment: '',
        scheme: '',
        recommendations: {
            listeningTraining: false,
            speechTherapy: false,
            reEvaluation: false,
            hearingAidOptimization: false,
           
            others: '',
        },
        validationAppointment: {
            date: '',
            program: '',
            mapNo: '',
            details: '',
         
        }
    });


   const handleSearch = async () => {
        if (!searchOpNumber.trim()) {
            setError('Please enter an OP number');
            return;
        }

        setLoading(true);
        setError('');
        
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/mapping/search/${searchOpNumber.trim()}`);
            
            if (response.ok) {
                const patientData = await response.json();
                setSearchResult(patientData);
                setIsFormVisible(true);
                
                // Pre-fill the form with existing data if available
                try {
                    const existingDataResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/mapping/${searchOpNumber.trim()}`);
                    if (existingDataResponse.ok) {
                        const existingData = await existingDataResponse.json();
                        console.log('Existing mapping data found:', existingData);
                        
                        // Parse mapping table from JSON if it's a string
                        let mappingTableData = [];
                        if (existingData.mapping_table) {
                            if (typeof existingData.mapping_table === 'string') {
                                mappingTableData = JSON.parse(existingData.mapping_table);
                            } else {
                                mappingTableData = existingData.mapping_table;
                            }
                        }
                        
                        // Ensure we have exactly 4 rows
                        while (mappingTableData.length < 4) {
                            mappingTableData.push({ programNo: '', mapNo: '', details: '', remarks: '' });
                        }
                        
                        setFormData(prev => ({
                            ...prev,
                            date: existingData.date_of_mapping || '',
                            impedance: existingData.impedance || '',
                            impedanceRemark: existingData.impedance_remark || '',
                            mappingTable: mappingTableData,
                            nextAppointment: existingData.next_appointment || '',
                            scheme: existingData.scheme || '',
                            recommendations: {
                                listeningTraining: existingData.listening_training || false,
                                speechTherapy: existingData.speech_therapy || false,
                                reEvaluation: existingData.re_evaluation || false,
                                hearingAidOptimization: existingData.hearing_aid_optimization || false,
                                others: existingData.other_recommendations || '',
                            },
                            validationAppointment: {
                                date: existingData.validation_date || '',
                                program: existingData.validation_program || '',
                                mapNo: existingData.validation_map_no || '',
                                details: existingData.validation_details || '',
                            }
                        }));
                    }
                } catch (error) {
                    console.log('No existing data found, starting with fresh form');
                }
            } else {
                const errorData = await response.json();
                setError(errorData.error || 'Patient not found. Please check the OP number.');
                setSearchResult(null);
                setIsFormVisible(false);
            }
        } catch (error) {
            console.error('Error searching for patient:', error);
            setError('Error searching for patient. Please check your connection.');
            setSearchResult(null);
            setIsFormVisible(false);
        } finally {
            setLoading(false);
        }
    };
  const handleDownloadClick = () => {
    setOpenPasswordModal(true);
  };

const handleDownloadConfirm = async () => {
  const correctKey = "Varun@6361";

  // Validate key entered in modal
  if (password !== correctKey) {
    alert("Incorrect key! Download canceled.");
    setPassword('');
    setOpenPasswordModal(false);
    return;
  }

  setOpenPasswordModal(false);
  setLoading(true);
  setSaveStatus({
    message: `Requesting Mapping CI ${downloadFormat}...`,
    severity: "info",
  });

  try {
    const resp = await fetch(
      `${process.env.REACT_APP_API_URL}/api/reports/download-form`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          table: "mapping_ci",
          formName: "Mapping_CI",
          format: downloadFormat,
          key: password   // 🔥 send KEY instead of password
        }),
      }
    );

    if (!resp.ok) {
      const body = await resp.json().catch(() => ({}));
      setSaveStatus({
        message: `Failed: ${body.message || resp.statusText}`,
        severity: "error",
      });
      return;
    }

    const blob = await resp.blob();
    const disposition = resp.headers.get("content-disposition") || "";

    let filename = `Mapping_CI_${Date.now()}.${
      downloadFormat === "excel" ? "xlsx" : "pdf"
    }`;

    const match = /filename="?([^"]+)"?/.exec(disposition);
    if (match && match[1]) filename = match[1];

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    setSaveStatus({
      message: `Download started: ${filename}`,
      severity: "success",
    });

  } catch (err) {
    console.error("Download error:", err);
    setSaveStatus({
      message: `Error downloading file: ${err.message}`,
      severity: "error",
    });
  } finally {
    setLoading(false);
    setPassword('');
  }
};


  const handlePasswordModalClose = () => {
    setOpenPasswordModal(false);
    setPassword('');
  };

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleRecommendationChange = (e) => {
        const { name, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            recommendations: { ...prev.recommendations, [name]: checked },
        }));
    };



    const handleValidationAppointmentChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            validationAppointment: { ...prev.validationAppointment, [name]: value },
        }));
    };

    const handleTableChange = (index, field, value) => {
        const updatedTable = [...formData.mappingTable];
        updatedTable[index] = { ...updatedTable[index], [field]: value };
        setFormData((prev) => ({ ...prev, mappingTable: updatedTable }));
    };

const handleSubmit = async () => {
        if (!searchOpNumber.trim()) {
            setError('Please search for a patient first');
            return;
        }

        setLoading(true);
        
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/mapping`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    opNumber: searchOpNumber.trim(),
                    ...formData
                }),
            });

            if (response.ok) {
                const result = await response.json();
                alert('Mapping data saved successfully!');
                console.log('Saved data:', result.data);
            } else {
                const error = await response.json();
                setError(`Error saving data: ${error.error}`);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            setError('Error submitting form');
        } finally {
            setLoading(false);
        }
    };


    return (
        <Card elevation={3} sx={{ borderRadius: 2, p: 3, maxWidth: 1200, mx: 'auto', mt: 4 }}>
            <CardContent>
                <Typography variant="h5" gutterBottom sx={{
                    fontWeight: 'bold',
                    color: '#1976d2',
                    mb: 3,
                    textAlign: 'center'
                }}>
                    Mapping Details
                </Typography>

                {/* Search Section */}
                <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
                    <Grid item xs={12} sm={8}>
                        <TextField
                            fullWidth
                            label="Search OP Number"
                            value={searchOpNumber}
                            onChange={(e) => setSearchOpNumber(e.target.value)}
                            variant="outlined"
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            onClick={handleSearch}
                            sx={{ height: '40px' }}
                        >
                            Search
                        </Button>
                    </Grid>
                </Grid>


                {/* Demographics */}
                {searchResult && (
                    <Paper elevation={1} sx={{ p: 3, mb: 4, bgcolor: '#e3f2fd', borderRadius: 2 }}>
                            <Box sx={{ position: 'absolute', top: 350, right: 140 }}>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<DownloadIcon />}
                onClick={handleDownloadClick}
                disabled={loading}
                sx={{ 
                  borderRadius: 2,
                  boxShadow: 2,
                  '&:hover': {
                    boxShadow: 4,
                    transform: 'translateY(-2px)',
                    transition: 'all 0.3s ease'
                  }
                }}
              >
                Download 
              </Button>
            </Box>
                        <Typography variant="h6" sx={{ fontWeight: 'medium', mb: 2 }}>
                            Demographic Information
                        </Typography>
                  <Grid container spacing={2}>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Typography><strong>Name:</strong> {searchResult.name || 'N/A'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Typography><strong>Age:</strong> {searchResult.age || 'N/A'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Typography><strong>IP Number:</strong> {searchResult.ip_number || 'N/A'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Typography><strong>OP Number:</strong> {searchResult.op_number || 'N/A'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Typography><strong>Phone:</strong> {searchResult.phone || 'N/A'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Typography><strong>Address:</strong> {searchResult.address || 'N/A'}</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography><strong>Medical History:</strong> {searchResult.history || 'N/A'}</Typography>
                                </Grid>
                            </Grid>
                    </Paper>
                )}

                {/* Main Form */}
                {isFormVisible && (
                    <Box sx={{ mt: 2 }}>
                        <Grid container spacing={3}>
                            {/* Section 1: Date and Impedance */}
                            <Grid container item xs={12} spacing={3}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Date"
                                        name="date"
                                        type="date"
                                        value={formData.date}
                                        onChange={handleFormChange}
                                        InputLabelProps={{ shrink: true }}
                                        size="small"
                                    />
                                </Grid>
                             <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Scheme (device obtained through)"
                                        name="scheme"
                                        value={formData.scheme}
                                        onChange={handleFormChange}
                                        size="small"
                                    />
                                </Grid>
                                <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth size="small">
          <InputLabel shrink={true}>Impedance</InputLabel>
          <Select
            name="impedance"
            value={formData.impedance}
            onChange={handleFormChange}
            label="Impedance"
            displayEmpty
            renderValue={(value) => value || 'Select Impedance'}
          >
            <MenuItem value="">Select</MenuItem>
            <MenuItem value="Acceptable">Acceptable</MenuItem>
            <MenuItem value="Not acceptable">Not acceptable</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      {/* Conditionally render textbox when "Not acceptable" is selected */}
      {formData.impedance === 'Not acceptable' && (
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            size="small"
            name="impedanceRemark"
            label="Remarks"
            value={formData.impedanceRemark}
            onChange={handleFormChange}
          />
        </Grid>
      )}
    </Grid>
                            </Grid>

                            {/* Section 2: Mapping Table */}
                            <Grid item xs={12}>
                                <Typography variant="h6" sx={{ fontWeight: 'medium', mb: 1 }}>
                                    Mapping Table
                                </Typography>
                                <Divider sx={{ mb: 2 }} />
                                <TableContainer component={Paper} sx={{ mb: 3 }}>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ fontWeight: 'bold' }}>Program No</TableCell>
                                                <TableCell sx={{ fontWeight: 'bold' }}>Map No</TableCell>
                                                <TableCell sx={{ fontWeight: 'bold' }}>Details</TableCell>
                                                <TableCell sx={{ fontWeight: 'bold' }}>Remarks</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {formData.mappingTable.map((row, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            value={row.programNo}
                                                            onChange={(e) => handleTableChange(index, 'programNo', e.target.value)}
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            value={row.mapNo}
                                                            onChange={(e) => handleTableChange(index, 'mapNo', e.target.value)}
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            value={row.details}
                                                            onChange={(e) => handleTableChange(index, 'details', e.target.value)}
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            value={row.remarks}
                                                            onChange={(e) => handleTableChange(index, 'remarks', e.target.value)}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>


                            {/* Section 4: Recommendations */}
                            <Grid item xs={12}>
                                <Card variant="outlined" sx={{ p: 3, backgroundColor: '#f9f9f9', borderRadius: 2 }}>
                                    <Typography variant="h6" sx={{ fontWeight: 'medium', mb: 2 }}>
                                        Recommendations
                                    </Typography>

                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={formData.recommendations.listeningTraining}
                                                        onChange={handleRecommendationChange}
                                                        name="listeningTraining"
                                                    />
                                                }
                                                label="Listening training"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={formData.recommendations.speechTherapy}
                                                        onChange={handleRecommendationChange}
                                                        name="speechTherapy"
                                                    />
                                                }
                                                label="Speech therapy"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={formData.recommendations.reEvaluation}
                                                        onChange={handleRecommendationChange}
                                                        name="reEvaluation"
                                                    />
                                                }
                                                label="Re-evaluation"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={formData.recommendations.hearingAidOptimization}
                                                        onChange={handleRecommendationChange}
                                                        name="hearingAidOptimization"
                                                    />
                                                }
                                                label="Hearing Aid Optimization"
                                            />
                                        </Grid>
                                    </Grid>

                                    <TextField
                                        fullWidth
                                        label="Other Recommendations"
                                        name="others"
                                        value={formData.recommendations.others}
                                        onChange={(e) =>
                                            setFormData((prev) => ({
                                                ...prev,
                                                recommendations: {
                                                    ...prev.recommendations,
                                                    others: e.target.value,
                                                },
                                            }))
                                        }
                                        size="small"
                                        sx={{ mt: 3 }}
                                        multiline
                                        rows={2}
                                    />
                                </Card>
                            </Grid>

                            {/* Section 5: Validation Appointment */}
                            <Grid item xs={12}>
                                <Card variant="outlined" sx={{ p: 3, backgroundColor: '#f9f9f9', borderRadius: 2 }}>
                                    <Typography variant="h6" sx={{ fontWeight: 'medium', mb: 2 }}>
                                        Validation Appointment
                                    </Typography>

                                    <Grid container spacing={2} sx={{ mb: 2 }}>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <TextField
                                                fullWidth
                                                label="Date"
                                                name="date"
                                                type="date"
                                                value={formData.validationAppointment.date}
                                                onChange={handleValidationAppointmentChange}
                                                InputLabelProps={{ shrink: true }}
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <FormControl fullWidth size="small">
                                                <InputLabel shrink={true}>Program</InputLabel>
                                                <Select
                                                    name="program"
                                                    value={formData.validationAppointment.program}
                                                    onChange={handleValidationAppointmentChange}
                                                    label="Program"
                                                    displayEmpty
                                                    renderValue={value => value || "Select Program"}
                                                >
                                                    <MenuItem value="">Select</MenuItem>
                                                    {['P1', 'P2', 'P3', 'P4'].map((opt) => (
                                                        <MenuItem key={opt} value={opt}>
                                                            {opt}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <TextField
                                                fullWidth
                                                label="Map No"
                                                name="mapNo"
                                                value={formData.validationAppointment.mapNo}
                                                onChange={handleValidationAppointmentChange}
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <TextField
                                                fullWidth
                                                label="Details"
                                                name="details"
                                                value={formData.validationAppointment.details}
                                                onChange={handleValidationAppointmentChange}
                                                size="small"
                                            />
                                        </Grid>
                                    </Grid>

                           
                                </Card>
                            </Grid>

                         {/* Password Modal */}
      <Dialog 
        open={openPasswordModal} 
        onClose={handlePasswordModalClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          Download Data
          <IconButton
            aria-label="close"
            onClick={handlePasswordModalClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              variant="outlined"
              sx={{ mb: 3 }}
            />
            <FormControl fullWidth>
              <InputLabel>Format</InputLabel>
              <Select
                value={downloadFormat}
                onChange={(e) => setDownloadFormat(e.target.value)}
                label="Format"
              >
                <MenuItem value="excel">Excel</MenuItem>
                <MenuItem value="pdf">PDF</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handlePasswordModalClose} color="inherit">
            Cancel
          </Button>
          <Button 
            onClick={handleDownloadConfirm} 
            variant="contained" 
            color="primary"
            disabled={!password}
          >
            Download
          </Button>
        </DialogActions>
      </Dialog>
                        </Grid>
                            {/* Submit Button */}
                                 <Grid item xs={12}>
                                   <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                                     <Button
                                       variant="contained"
                                       color="primary"
                                       onClick={handleSubmit}
                                       sx={{ px: 5, py: 1.25, borderRadius: 2 }}
                                     >
                                       Submit
                                     </Button>
                                   </Box>
                                 </Grid>
                    </Box>
                    
                )}
                
            </CardContent>
               
        </Card>
    );
};

export default Mapping;